import { Fragment } from 'react';
import { ArrowSmallDown, ArrowSmallDownEnd, ArrowSmallUp, ArrowSmallUpEnd, Delete } from '@sas/react-svg';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../../theme';
import { postfixTestId } from '../../../util/testId';
import { Button, ButtonVariant } from '../../Button';
import bundle from '../NovaComponents-DualSelector-gui-icu.properties';
import './ReorderLayout.css';
import cn from './ReorderLayout.css.json';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const ReorderButton = props => {
  const dt = useDesignTokens();
  const reorderButtonTokens = renderInlineCssVars({
    spacing: dt.tokens['space-base-null']
  }, 'reorder-button');
  const localize = useTextLocalizer();
  const reorderItems = [{
    direction: 'top',
    icon: ArrowSmallUpEnd,
    isDisabled: props.reorderButtonState.disableUp,
    hide: props.hideReorder
  }, {
    direction: 'up',
    icon: ArrowSmallUp,
    isDisabled: props.reorderButtonState.disableUp,
    hide: props.hideReorder
  }, {
    direction: 'down',
    icon: ArrowSmallDown,
    isDisabled: props.reorderButtonState.disableDown,
    hide: props.hideReorder
  }, {
    direction: 'bottom',
    icon: ArrowSmallDownEnd,
    isDisabled: props.reorderButtonState.disableDown,
    hide: props.hideReorder
  }, {
    direction: 'delete',
    icon: Delete,
    isDisabled: props.reorderButtonState.disableDelete,
    hide: props.hideDelete
  }];
  return /*#__PURE__*/_jsx(Fragment, {
    children: reorderItems.map((item, i) => {
      if (item.hide) {
        return null;
      } else {
        return /*#__PURE__*/_jsx("div", {
          className: cn.reorderButtons,
          style: reorderButtonTokens,
          children: /*#__PURE__*/_jsx(Button, {
            testId: postfixTestId(props.testId, item.direction),
            variant: ButtonVariant.Icon,
            icon: {
              icon: item.icon,
              tooltip: localize(`reorderButton.${item.direction}.button.tooltip.label`)
            },
            onPress: () => props.onPress(item.direction),
            disabled: item.isDisabled,
            ariaLabel: localize(`reorderButtons.${item.direction}.button.aria`, {
              targetListLabel: props.targetLabel
            })
          })
        }, i);
      }
    })
  });
};
//# sourceMappingURL=ReorderLayout.js.map